import React from 'react';

import Dashboard from 'cbm-dashboard';

const CBMDashboard = () => (
  <Dashboard />
);

export default CBMDashboard;
